import React from 'react';
import PressGallery from './PressGallery';

const TestimonialSection: React.FC = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center mx-auto mb-5" data-aos="fade-up" data-aos-delay="100" style={{ maxWidth: '500px' }}>
          <div className="d-inline-block rounded-pill bg-secondary text-primary py-1 px-3 mb-3">
            Testimonial
          </div>
          <h1 className="display-6 mb-5">What People Say About Us</h1>
        </div>
        <PressGallery />
      </div>
    </div>
  );
};

export default TestimonialSection;
